<template >
    <q-card class="q-pa-md splash">
        <h4 class="text-center q-mt-sm q-mb-md">Feedback & More Information</h4>


        <div class="q-pa-sm">
            <div class="text-h5">Questions or Feedback</div>
            <div class="text-body2 row items-center">
                <div class="col-8">
                    Ask a question or provide other feedback via
                    <span class="link">
                        <a href="https://forms.office.com/r/bNPTEik3id" target="_blank">this form</a>
                    </span>.
                    If you expereinced a problem while using the tool, click the following button to copy any error messages to your clipboard.  Then paste this error message into the feedback form.
                </div> 
                <div class="q-ml-sm col-3">
                    <q-btn class="" @click="copyErrors">Copy Error Messages</q-btn>
                </div>  
            </div>

        </div>
        <div class="row  q-pt-md q-pl-sm q-pr-sm">
            Please cite as: Marine Mapping Tool, Northeast and Mid-Atlantic [Web application, version {{ appVersion }}.]. 2025. Design and content by M.M. Ribera. Web application by E.H. Martin. Conceptual guidance by M. Anderson, T. Jedele, and C. McGuire. The Nature Conservancy, Center for Resilient Conservation Science. https://www.maps.tnc.org/marinemap/ne
        </div>


        <div class="row justify-center">
            <q-btn class="q-ma-sm" label="OK" v-close-popup outline />
        </div>

    </q-card>
    <q-dialog v-model="splash" persistent aria-label="Welcome dialog">
        <Splash />
    </q-dialog>
    <div v-for="(infoObj, name) in infoDialogs" :key="name">
        <q-dialog v-model="infoObj.model">
            <InfoDialog :html="infoObj.text" :name="infoObj.pName" />
        </q-dialog>
    </div>
</template>
<script setup>

import {  onMounted, ref } from 'vue'
import tncLogo from '../assets/TNCLogoPrimary_RGB.png'
import crcsLogo from '../assets/CRCS_logo.png'
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import InfoDialog from "./InfoDialog.vue";
import Splash from "../components/Splash.vue"

const { errorMessages } = useHelpers();

const { appVersion } = useMapItems();

const splash = ref(false)
const infoDialogs = ref({

    indigenous: {
        pName: "Indigenous Lands",
        model: false,
        text: "<div class='q-pa-sm'>In the original version of the Resilient Land Mapping Tool, Indigenous lands (U.S. Department of Interior Indian Affairs, Land Area Representation) were greyed-out in recognition of their status as sovereign nations.  In the intervening years, we have had conversations with representatives from several tribes. While there is not a single voice that speaks for all tribes, a common theme we heard was that an analysis based on publicly accessible, remote-sensed data, such as ours, does not divulge any sensitive information about these lands.  Further, by previously excluding Indigenous lands from the publicly-accessible version of the tool, we added friction to the process of the tribes themselves understanding and applying the data.  For this reason, while Indigenous lands are turned on by default in the map, they are no longer password protected in this new version of the Resilient Land Mapping Tool and can be turned on and off with the layer control located under 'Reference Layers'.</div>"
    }
})

const copyErrors = () =>{
    const errorReport = errorMessages.value.join('\n');
    // console.log(errorReport)
    navigator.clipboard.writeText(errorReport).then(() => {
        console.log('Error messages copied to clipboard');
    }).catch(err => {
        console.error('Failed to copy error messages to clipboard:', err);
    });
}


onMounted(() => {

});




</script>
<style scoped>
.legal{
    font-size: x-small;
    color: #808080
}
.splash{
  min-width: 60%;
}

.link{
    color: #0059ff;
    text-decoration: underline;
    cursor: pointer;
}
</style>